import { render } from "./authorizedLogin.vue?vue&type=template&id=9b9e4be6&scoped=true"
import script from "./authorizedLogin.vue?vue&type=script&lang=js"
export * from "./authorizedLogin.vue?vue&type=script&lang=js"

import "./authorizedLogin.vue?vue&type=style&index=0&id=9b9e4be6&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9e4be6"]])

export default __exports__